// Typelizer digest df0e548f0bb842cf14d24cdf4624804b
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** POST /c/:company_id/counterparties/:counterparty_id/contacts */
  create: (
    params: { counterpartyId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/counterparties/:counterparty_id/contacts', params, options),
    method: 'post',
  }),

  /** PATCH /c/:company_id/counterparties/:counterparty_id/contacts/:id */
  update: (
    params: { counterpartyId: string | number; id: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/c/:company_id/counterparties/:counterparty_id/contacts/:id', params, options),
    method: 'patch',
  }),

  /** DELETE /c/:company_id/counterparties/:counterparty_id/contacts/:id */
  destroy: (
    params: { counterpartyId: string | number; id: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/c/:company_id/counterparties/:counterparty_id/contacts/:id', params, options),
    method: 'delete',
  }),
}
